"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTabs = exports.StyledTabPanelContainer = exports.StyledTabPanel = exports.StyledTabListContainer = exports.StyledTabList = exports.StyledTabLabel = exports.StyledTab = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _grid = require("../../fuse-responsive-grid/src/grid");
var _typography = require("../../fuse-typography-element/src/typography");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledTabs = exports.StyledTabs = _styledComponents["default"].div.attrs({
  className: 'fuse-tabs'
}).withConfig({
  displayName: "styled-tabs__StyledTabs",
  componentId: "sc-58e75g-0"
})(["overflow-x:auto;scrollbar-width:none;"]);
var StyledTab = exports.StyledTab = _styledComponents["default"].button.attrs({
  className: 'fuse-tabs__tab',
  'data-testid': 'fuse-tabs-tab-test-id'
}).withConfig({
  displayName: "styled-tabs__StyledTab",
  componentId: "sc-58e75g-1"
})(["position:relative;width:max-content;padding:var(--spacing-global-space4) var(--spacing-global-space5);outline:0;border:0;background:var(--color-global-grey200);scroll-snap-align:start;cursor:pointer;&:after{display:block;content:'';position:absolute;bottom:0;left:0;width:100%;border-bottom:var(--border-width-s) solid var(--color-global-grey400);}&:active,&.active{background:var(--color-global-grey100);.fuse-tabs__tab-label{font-weight:var(--font-weight-heading);}&:after{border-bottom:var(--border-width-s) solid var(--color-brand-mid);}}@media not all and (pointer:coarse){&:hover{background:var(--color-global-grey300);.fuse-tabs__tab-label{font-weight:var(--font-weight-heading);color:var(--color-brand-dark);}}}&:focus{background:var(--color-global-grey300);outline:var(--border-width-s) solid var(--color-functional-focus);outline-offset:-2px;&&:after{border-bottom:0;}.fuse-tabs__tab-label{font-weight:var(--font-weight-heading);color:var(--color-brand-dark);}}"]);
var StyledTabLabel = exports.StyledTabLabel = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-tabs__tab-label',
  'data-testid': 'fuse-tabs-tab-label-test-id'
}).withConfig({
  displayName: "styled-tabs__StyledTabLabel",
  componentId: "sc-58e75g-2"
})(["margin-bottom:0;pointer-events:none;width:max-content;text-align:center;&:before{display:block;content:attr(title);font-weight:var(--font-weight-heading);height:0;overflow:hidden;visibility:hidden;}"]);
var StyledTabListContainer = exports.StyledTabListContainer = _styledComponents["default"].div.attrs({
  className: 'fuse-tabs__tab-list-container',
  'data-testid': 'fuse-tabs-tab-list-container-test-id'
}).withConfig({
  displayName: "styled-tabs__StyledTabListContainer",
  componentId: "sc-58e75g-3"
})(["position:relative;"]);
var StyledTabList = exports.StyledTabList = _styledComponents["default"].div.attrs({
  className: 'fuse-tabs__tab-list',
  'data-testid': 'fuse-tabs-tab-list-test-id'
}).withConfig({
  displayName: "styled-tabs__StyledTabList",
  componentId: "sc-58e75g-4"
})(["display:flex;position:relative;gap:var(--spacing-global-space3);margin-left:var(--spacing-global-space5);margin-bottom:var(--spacing-global-space6);overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{display:none;}box-shadow:inset 0px -2px 0px var(--color-global-grey400);@media only screen and (min-width:", "){margin-left:var(--spacing-global-space6);}@media only screen and (min-width:", "){margin-left:0;margin-right:0;margin-bottom:var(--spacing-global-space7);scroll-snap-type:none;}"], _grid.gridConfig.m.minWidth, _grid.gridConfig.l.minWidth);
var StyledTabPanelContainer = exports.StyledTabPanelContainer = _styledComponents["default"].div.attrs({
  className: 'fuse-tabs__tab-panel-container',
  'data-testid': 'fuse-tabs-tab-panel-container-test-id'
}).withConfig({
  displayName: "styled-tabs__StyledTabPanelContainer",
  componentId: "sc-58e75g-5"
})([""]);
var StyledTabPanel = exports.StyledTabPanel = _styledComponents["default"].div.attrs({
  className: 'fuse-tabs__tab-panel',
  'data-testid': 'fuse-tabs-tab-panel-test-id'
}).withConfig({
  displayName: "styled-tabs__StyledTabPanel",
  componentId: "sc-58e75g-6"
})(["width:100%;&:focus{outline:0;}"]);